import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-900 text-background-100" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl font-bold text-background-50 mb-4">奇妙漫画</h4>
            <p className="text-sm text-secondary-300 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.home')}</Link></li>
              <li><Link to="/category/hanman" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.category')}</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">{t('nav.about')}</Link></li>
              <li><a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">{t('footer.feedback')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">{t('footer.categories')}</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">{t('footer.contactInfo')}</h4>
            <ul className="space-y-2 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i> support@qimiaomanhua.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i> 奇妙漫画
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line"></i> @奇妙漫画官方
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">{t('footer.terms')}</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">{t('footer.privacy')}</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">{t('footer.feedback')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}